/*
 * @Author: Q in
 * @Date: 2025-05-28 10:58:24
 * @LastEditors: Q in 
 * @LastEditTime: 2026-05-21 18:07:16
 * @FilePath: /new_kefu_pc/src/utils/publicFn.js
 * @Description: 公共函数
 */
import { Message } from 'element-ui';

// 防抖原理：一定时间内，只有最后一次操作，再过wait毫秒后才执行函数
export function debounce(func, delay = 500) {
	let timer;

	return function (...args) {
		if (timer) {
			clearTimeout(timer);
		}

		timer = setTimeout(() => {
			func.apply(this, args);
			timer = null;
		}, delay);
	};
}

// 节流原理：在一定时间内，只能触发一次
export function throttle(func, delay = 500) {
	let timer;
	let flag = true;

	return function (...args) {
		if (!flag) {
			return;
		}

		if (timer) {
			clearTimeout(timer);
		}

		func.apply(this, args);
		flag = false;
		timer = setTimeout(() => {
			flag = true;
			timer = null;
		}, delay);
	};
}

// 复制文本到剪贴板
export function copy(str, message = '复制成功') {
	const input = document.createElement('input');
	input.value = str;
	document.body.appendChild(input);
	input.select();
	document.execCommand('copy');
	document.body.removeChild(input);
	Message.success(message);
}

/**
 * 通用时间格式化函数
 * @param {string|number|Date} input - 时间输入（时间戳、日期字符串、Date对象）
 * @param {string} format - 输出格式，默认为 'YYYY-MM-DD'
 * @returns {string} 格式化后的时间字符串
 */
export function formatTime(input, format = 'YYYY-MM-DD') {
	// 处理输入，统一转换为 Date 对象
	let date;

	if (input === null || input === undefined || input === '') {
		return '';
	}

	if (input instanceof Date) {
		// 如果是 Date 对象，直接使用
		date = input;
	} else if (typeof input === 'number' || !isNaN(Number(input))) {
		// 如果是数字或数字字符串（时间戳）
		// 判断是秒级时间戳还是毫秒级时间戳
		let timestamp = Number(input);
		if (timestamp.toString().length === 10) {
			// 秒级时间戳（10位）转换为毫秒
			timestamp = timestamp * 1000;
		}
		date = new Date(timestamp);
	} else if (typeof input === 'string') {
		// 如果是日期字符串
		date = new Date(input);
	} else {
		console.error('不支持的时间格式');
		return '';
	}

	// 检查日期是否有效
	if (isNaN(date.getTime())) {
		console.error('无效的时间');
		return '';
	}

	// 获取日期组件
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	const hours = String(date.getHours()).padStart(2, '0');
	const minutes = String(date.getMinutes()).padStart(2, '0');
	const seconds = String(date.getSeconds()).padStart(2, '0');

	// 定义格式映射
	const formatMap = {
		YYYY: year,
		MM: month,
		DD: day,
		HH: hours,
		mm: minutes,
		ss: seconds,
		YY: String(year).slice(-2),
		M: date.getMonth() + 1,
		D: date.getDate(),
		H: date.getHours(),
		m: date.getMinutes(),
		s: date.getSeconds()
	};

	// 替换格式
	let result = format;
	for (let key in formatMap) {
		const regex = new RegExp(key, 'g');
		result = result.replace(regex, formatMap[key]);
	}

	return result;
}
